import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppState } from '../../state/app.state';
import { ITransactionsState, ITransactionStates } from '../../state/transactions-state';
import { createEntityAdapter } from '@ngrx/entity';
import { ITransaction } from 'src/app/models/transactions';

export const getTransactionsStates = createFeatureSelector<IAppState, ITransactionStates>('transactions');

export const transactionAdapter = createEntityAdapter<ITransaction>({
    selectId: (transaction: ITransaction) => transaction.generalLedgerId
});


export const selectCashTransactionsState = createSelector(
    getTransactionsStates,
    (state) => {
        return state.cash;
    }
)

export const selectSecuritiesTransactionsState = createSelector(
    getTransactionsStates,
    (state) => {
        return state.securities;
    }
)

export const selectRevenueTransactionsState = createSelector(
    getTransactionsStates,
    (state) => {
        return state.revenue;
    }
)

export const selectTransactionsState = createSelector(
    getTransactionsStates,
    (state) => {
        return state;
    }
);